import { z } from "zod";
import { MentionStatus } from "./Mention";

export const RequestGroupKey = z.enum(["active", "assigned-to-me", "closed"]);
export const MemberGroupKey = z.enum([
    "default",
    "assigned-to-me",
    "archived",
    "lapsed-and-churned",
]);
export const TasksGroupKey = MentionStatus;

export type RequestGroupKey = z.infer<typeof RequestGroupKey>;
export type MemberGroupKey = z.infer<typeof MemberGroupKey>;
export type TasksGroupKey = z.infer<typeof TasksGroupKey>;

export const MemberGroupTitles: Record<MemberGroupKey, string> = {
    default: "Members",
    "assigned-to-me": "My members",
    archived: "Archived members",
    "lapsed-and-churned": "Lapsed and churned",
};
